import { get, writable } from 'svelte/store';
import { TimesheetService } from '../../services/timesheet.service';
import moment from 'moment';
import { user } from '../../app.store';
import { DossierService } from '../../services/dossier.service';
import { ActivityService } from '../../services/activity.service';
import { ActivityTypesService } from '../../services/activity-types.service';
import { PortalUserService } from '../../services/portal-user.service';
let filterInitialized = false;
export const loading = writable(false);
export const filter = writable({ criteria: {}, params: null, sorting: "" });
export const selection = writable({ dateKey: '', dossierId: null, customerId: null });
export const timesheet = writable(null);
export const activities = writable([]);
export const activity = writable(null);
export const dossier = writable(null);
export const extraContentVisible = writable(false);
export const applyUserRevenue = writable(false);
export async function initTimesheet() {
    if (filterInitialized === false) {
        let weekday = moment().weekday();
        let nowMom = moment();
        // if today is sunday, go back 6 days
        if (weekday == 0) {
            nowMom = nowMom.add(-6, "day");
        }
        else {
            // start of week (sunday) + 1 day -> monday
            nowMom = nowMom.startOf("week").add(1, "day");
        }
        let now = nowMom.local().toDate();
        //let now = moment().startOf("week").add(1, "day").local().toDate();
        let u = get(user);
        let criteria = { dateFrom: now, portalUserId: u.oid };
        filter.set({ criteria: criteria, params: null, sorting: "" });
        filterInitialized = true;
    }
    timesheet.set(null);
    await load();
}
export async function load() {
    loading.set(true);
    // resetSelection();
    activities.set([]);
    activity.set(null);
    try {
        loadSettings();
        let _filter = get(filter);
        let _resp = await TimesheetService.getTimesheet(_filter);
        timesheet.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export async function loadActivities(date, dossierId, customerId) {
    loading.set(true);
    try {
        // activities.set([]);
        let currFilter = get(filter);
        let _filter = Object.assign(Object.assign({}, currFilter), { criteria: Object.assign({}, currFilter.criteria) });
        _filter.criteria.dateFrom = date;
        _filter.criteria.dossierId = dossierId;
        _filter.criteria.customerId = customerId;
        let _resp = await TimesheetService.GetTimesheetDaySummary(_filter);
        activities.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
function loadSettings() {
    let theUser = get(user);
    let _applyUserRevenue = theUser != null ? theUser.regionSettings.applyUserRevenue : false;
    applyUserRevenue.set(_applyUserRevenue === 1);
}
async function filterAddDays(numDays) {
    let _filter = get(filter);
    let criteria = Object.assign({}, _filter.criteria);
    let d = moment(criteria.dateFrom).add(numDays, "day").local().toDate();
    criteria.dateFrom = d;
    filter.set(Object.assign(Object.assign({}, _filter), { criteria: criteria }));
}
export async function prevDay() {
    filterAddDays(-1);
    await load();
}
export async function nextDay() {
    filterAddDays(1);
    await load();
}
export async function prevWeek() {
    filterAddDays(-7);
    await load();
}
export async function nextWeek() {
    filterAddDays(7);
    await load();
}
export function setSelection(entry) {
    selection.set({ dateKey: entry.dateKey, dossierId: entry.dossierId, customerId: entry.customerId });
    activities.set([]);
    activity.set(null);
    let date = moment(entry.dateKey).local().toDate();
    loadActivities(date, entry.dossierId, entry.customerId);
}
export function resetSelection() {
    selection.set({ dateKey: '', dossierId: null, customerId: null });
    activities.set([]);
    activity.set(null);
}
export async function onAddActivity() {
    let _selection = get(selection);
    let date = null;
    let dossierId = null;
    let customerId = null;
    dossier.set(null);
    if (_selection != null) {
        date = moment(_selection.dateKey).local().toDate();
        dossierId = _selection.dossierId;
        customerId = _selection.customerId;
        if (dossierId != null) {
            let _dossier = await fetchDossier(dossierId);
            dossier.set(_dossier);
            customerId = _dossier.customerId;
        }
    }
    else {
        date = moment().startOf("day").local().toDate();
    }
    let year = date.getFullYear();
    let authUser = get(user);
    let _userResp = await PortalUserService.fetchPortalUser(authUser.oid);
    let _us = _userResp.payload;
    let _activity = {
        oid: 0, date: date, year: year, title: '',
        portalUserId: authUser.oid, dossierId: dossierId, customerId: customerId,
        hourlyRevenue: 0, hourlyLaborCost: _us.hourlyCost,
        costs: 0, costsAmount: 0, billed: 0, notes: ''
    };
    if (get(applyUserRevenue) == true) {
        _activity.hourlyRevenue = _us.hourlyRevenue;
    }
    activity.set(_activity);
}
export async function onEditActivity(activityId) {
    let _resp = await ActivityService.fetchActivity(activityId);
    let _activity = _resp.payload;
    if (_activity != null) {
        if (_activity.dossierId != null) {
            let _dossier = await fetchDossier(_activity.dossierId);
            dossier.set(_dossier);
        }
        activity.set(_activity);
    }
}
export async function onSaveActivity() {
    await saveActivityExt(false);
}
export async function onSaveAsNewActivity() {
    await saveActivityExt(true);
}
export async function saveActivityExt(asNew) {
    let _record = get(activity);
    if (asNew)
        _record.oid = 0;
    let _resp = await ActivityService.saveActivity(_record);
    activity.set(null);
    dossier.set(null);
    load();
    let _selection = get(selection);
    if (_selection != null) {
        let date = moment(_selection.dateKey).local().toDate();
        let dossierId = _selection.dossierId;
        let customerId = _selection.customerId;
        loadActivities(date, dossierId, customerId);
    }
}
export function onCancelActivity() {
    activity.set(null);
    dossier.set(null);
}
export async function fetchDossier(dossierId) {
    let _resp = await DossierService.fetchDossier(dossierId);
    let _dossier = _resp.payload;
    dossier.set(_dossier);
    return _dossier;
}
export async function fetchAtivityType(activityTypeId) {
    let _resp = await ActivityTypesService.fetchActivityType(activityTypeId);
    return _resp.payload;
}
